// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kt-3";
export var downloadButton = "_kt-4";
export var fileContainer = "_kt-9 _kt-7";
export var fileContainerBase = "_kt-7";
export var fileContainerBaseSm = "_kt-a _kt-7";
export var fileContainerFixedHeight = "_kt-8 _kt-7";
export var fileContainerFixedHeightSm = "_kt-c _kt-a _kt-7";
export var fileContainerSm = "_kt-b _kt-a _kt-7";
export var fileInfo = "_kt-5";
export var fileInfoWidthRestricted = "_kt-6";
export var fileType = "_kt-1";
export var fileTypeName = "_kt-2";
export var fileTypeSm = "_kt-d _kt-1";
export var image = "_kt-0";
export var link = "_kt-f";
export var overflowEllipsis = "_kt-e";